import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {HomeComponent} from './pages/home/home.component';
import {TabsComponent} from './pages/tabs/tabs.component';

import {MsalGuard} from '@azure/msal-angular';
import {AuthenticationGuard} from './shared/guards/authentication.guard';

import { EmailConfigurationComponent } from './pages/email-configuration/email-configuration.component';
import { AdminConfigurationComponent } from './pages/admin-configuration/admin-configuration.component';
import { OfficesComponent } from './pages/offices/offices.component';
import { CitiesComponent } from './pages/cities/cities.component';
import { UsersTableComponent } from './pages/users/users-table/users-table.component';
import { InwardRequestsComponent } from './pages/inward-requests/inward-requests.component';
import { InwardRegComponent } from './pages/inward-requests/inward-reg/inward-reg.component';
import { OutwardComponent } from './pages/outward/outward.component';
import { AddOutwardComponent } from './pages/outward/add-outward/add-outward.component';
import { ProgressbarComponent } from './shared/components/progressbar/progressbar.component';
import { ViewOutwardComponent } from './pages/outward/view-outward/view-outward.component';
import { ViewInwardComponent } from './pages/inward-requests/view-inward/view-inward.component';
//import { EditOutwardComponent } from './pages/outward/edit-outward/edit-outward.component';
import { OutwardApproverComponent } from './pages/outward-approver/outward-approver.component';
import { EditRequestComponent } from './pages/inward-requests/edit-request/edit-request.component';
import { SmallProgressBarComponent } from './shared/components/small-progress-bar/small-progress-bar.component';
import { ViewOutwardApproverComponent } from './pages/outward-approver/view-outward-approver/view-outward-approver.component';
import { OutwardL2approverComponent } from './pages/outward-l2approver/outward-l2approver.component';
import { ViewOutwardL2approverComponent } from './pages/outward-l2approver/view-outward-l2approver/view-outward-l2approver.component';
import { OutwardSupervisorComponent } from './pages/outward-supervisor/outward-supervisor.component';
import { ViewOutwardSupervisorComponent } from './pages/outward-supervisor/view-outward-supervisor/view-outward-supervisor.component';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';
import { AuditConfigurationComponent } from './pages/audit-trail/configuration/audit-configuration/audit-configuration.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
//import { ProgressbarComponent } from './shared/components/progressbar.component';
const routes: Routes = [
  {
    path: 'access-denied',
    component: AccessDeniedComponent
  },
  {
    path: 'tabs',
    component: TabsComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'emailConf',
    component: EmailConfigurationComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'AdminConf',
    component: AdminConfigurationComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'Office',
    component: OfficesComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'Users',
    component: UsersTableComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'Outward',
    component: OutwardComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'AddOutward',
    component: AddOutwardComponent,
    canActivate:[AuthenticationGuard]
},
  {
    path: 'Cities',
    component: CitiesComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'EmailConfiguration',
    component: EmailConfigurationComponent
  },
  {
    path:'Progressbar',
    component:ProgressbarComponent,
    canActivate:[AuthenticationGuard]
  },
  {
    path: 'Inward',
    component: InwardRequestsComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path:'ViewOutward',
    component:ViewOutwardComponent,
    canActivate:[AuthenticationGuard]
  },
  {
    path: 'Inward/InwardNewReg',
    component: InwardRegComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path:'EditOutward/:id',
  component: AddOutwardComponent,
  canActivate:[AuthenticationGuard]
  },
  {
    path: 'Inward/ViewInwardReq/:id',
    component: ViewInwardComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'Inward/EditInwardReq/:id',
    component: EditRequestComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path:'smallProgress',
    component:SmallProgressBarComponent,
    canActivate:[AuthenticationGuard]
  },
  { 
    path: 'ViewOutward/:id', 
    component: ViewOutwardComponent,
    canActivate:[AuthenticationGuard]
  },
  {
  path: 'OutwardL1Approver',
  component: OutwardApproverComponent,
  canActivate: [AuthenticationGuard]
},
{
  path: 'ViewOutwardL1Approver',
  component: ViewOutwardApproverComponent,
  canActivate: [AuthenticationGuard]
},
{ 
  path: 'ViewOutwardL1Approver/:id', 
  component: ViewOutwardApproverComponent,
   canActivate: [AuthenticationGuard]
},
{
path: 'OutwardL2Approver',
component: OutwardL2approverComponent,
canActivate: [AuthenticationGuard]
},
{
path: 'ViewOutwardL2Approver',
component: ViewOutwardL2approverComponent,
canActivate: [AuthenticationGuard]
},
{ 
path: 'ViewOutwardL2Approver/:id', 
component: ViewOutwardL2approverComponent,
 canActivate: [AuthenticationGuard]
},
{
path: 'OutwardSupervisor',
component: OutwardSupervisorComponent,
canActivate: [AuthenticationGuard]
},
{
path: 'ViewOutwardSupervisor',
component: ViewOutwardSupervisorComponent,
canActivate: [AuthenticationGuard]
},
{ 
path: 'ViewOutwardSupervisor/:id', 
component: ViewOutwardSupervisorComponent,
 canActivate: [AuthenticationGuard]
},
{
  path: 'AuditConfiguration',
  component: AuditConfigurationComponent,
  canActivate: [AuthenticationGuard]
},
{
  path: 'not-found', // 404
  component: NotFoundComponent,
},
{
  path: '**',
  redirectTo: 'not-found'
}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
